'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UrlParts = require('./parts/UrlParts');

var _UrlParts2 = _interopRequireDefault(_UrlParts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * IMPORTANT
 * ------------
 * The frontend is not capable of properly validating email addresses.
 * See https://git.hubteam.com/HubSpot/PatternValidation/issues/49
 *
 * Because of this, it is required to validate on the backend for any
 * scenario that prompts a user in product for an email address.
 *
 * More info - https://product.hubteam.com/docs/frontend/docs/input-validation.html
 */
var EMAIL_ADDRESS_REGEX = new RegExp('^(?:.+)@' + _UrlParts2.default.domain + '$');

exports.default = EMAIL_ADDRESS_REGEX;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PatternValidationJS/static-1.103/js/regex/EmailAddressRegex.js
// module id = 1105
// module chunks = 2 3